<template>
  <img
    :src="$coconala.serviceImageURL(filePath, getWidth, getHeight)"
    :alt="serviceName"
    :style="style"
    @load="$emit('loaded')"
    v-if="getType === 'swiper-immediate'"
  />
  <img
    :src="$coconala.serviceImageURL(filePath, getWidth, getHeight)"
    :alt="serviceName"
    :style="style"
    loading="lazy"
    decoding="async"
    v-else
  />
</template>
<script>
export default {
  name: 'CServiceImage',
  props: {
    filePath: {
      type: String,
      default: ''
    },
    serviceName: {
      type: String,
      default: ''
    },
    // 表示サイズ（横、単位）
    width: {
      type: String,
      default: ''
    },
    // 表示サイズ（縦、単位）
    height: {
      type: String,
      default: ''
    },
    // 取得サイズ（横）
    getWidth: {
      type: Number,
      default: 230
    },
    // 取得サイズ（縦）
    getHeight: {
      type: Number,
      default: 190
    },
    getType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hasError: false
    }
  },
  mounted() {
    this.$el.onerror = () => {
      this.hasError = true
    }
  },
  computed: {
    style() {
      const style = {}
      if (this.width) Object.assign(style, { width: this.width })
      if (this.height) Object.assign(style, { height: this.height })
      return style
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceImage {
  width: 100%;
  height: auto;
}
</style>
